import {  ALL_CLASS_TYPE_LIST } from './actionType'

//
export const allClassTypeList = (data) => ({
  type: ALL_CLASS_TYPE_LIST,
  payload: data,
})
